var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("The popup will appear to "+_vm._s(_vm.data)+" visitors")])])}
var staticRenderFns = []

export { render, staticRenderFns }